// /plastic — Facial Plastic & Reconstructive Surgery
import { icons } from "../../components/icons";
import { plasticGroupPage } from "./shared";

export default function plasticFacePage() {
  return plasticGroupPage({ prefix: "pf", heroImg: "hero.webp", icon: icons.spa });
}
